export const brandInfo = {
  name: "微光爆料",
  slogan: "让每一条线索，都被认真对待",
  email: "tougao@weiguangbaoliao.com",
  replyNote: "工作日 9:00–21:00 之间提交，通常当天就能收到人工回复。",
};

export const navLinks = [
  { label: "投稿流程", href: "#process" },
  { label: "核心问题", href: "#questions" },
  { label: "审核时长", href: "#timeline" },
  { label: "隐私保护", href: "#privacy" },
  { label: "稿费结算", href: "#fee" },
  { label: "格式要求", href: "#format" },
  { label: "常见问题", href: "#faq" },
];

export const heroStats = [
  { value: "4 小时", label: "平均初审时长", icon: "ri-timer-flash-line" },
  { value: "7 天", label: "最长发布窗口", icon: "ri-calendar-check-line" },
  { value: "3 档", label: "匿名保护等级", icon: "ri-shield-user-line" },
  { value: "24 小时", label: "稿费最快到账", icon: "ri-wallet-3-line" },
];

export const processSteps = [
  {
    step: "01",
    title: "提交线索",
    desc: "通过投稿表单填写事件时间、地点、经过与可核验的细节，可附上联系方式或选择完全匿名。",
    icon: "ri-send-plane-line",
    time: "约 3 分钟",
  },
  {
    step: "02",
    title: "初步核验",
    desc: "编辑会交叉比对公开信息与已有关联线索，判断事件是否具备基本真实性与公共价值。",
    icon: "ri-search-eye-line",
    time: "平均 4 小时",
  },
  {
    step: "03",
    title: "补充材料",
    desc: "若关键细节缺失，编辑会通过你预留的渠道联系补充，只针对存疑点，不追问多余隐私。",
    icon: "ri-attachment-2",
    time: "1 个工作日内",
  },
  {
    step: "04",
    title: "编辑发布",
    desc: "通过核验的线索进入发布队列，按敏感度决定发表节奏，并同步告知你发布状态与稿费结果。",
    icon: "ri-newspaper-line",
    time: "24–72 小时",
  },
];

export const keyQuestions = [
  {
    id: "publish-time",
    icon: "ri-time-line",
    title: "投稿后多久发布？",
    summary: "初审平均 4 小时，从投稿到正式发布通常为 24–72 小时，最迟不超过 7 天。",
    points: [
      "工作时段内提交的线索，初审平均 4 小时内完成，夜间提交顺延至次日 9:00 开始处理。",
      "普通线索从通过初审到发布，一般为 24–72 小时；涉及多方核实的复杂线索会适当延长。",
      "自投稿之日起 7 天内未收到发布或补材料通知，视为暂不采用，你可以放心转投其他渠道。",
    ],
    note: "无论是否采用，我们都会给出明确结果，不会让线索无声无息地消失。",
  },
  {
    id: "privacy",
    icon: "ri-shield-user-line",
    title: "是否会保护投稿人？",
    summary: "默认匿名处理，联系方式仅核验编辑可见，正文不出现可反推身份的信息。",
    points: [
      "对外发布时默认隐去真实姓名、职务、工号、内部群名称等可识别身份的信息。",
      "你的联系方式只在核验环节可见，不会写入正文，也不会提供给被爆料方。",
      "如线索敏感度较高，可申请最高等级匿名，由专门编辑单线对接。",
    ],
    note: "请在投稿时主动说明需要保护的身份信息，越早说明，保护越彻底。",
  },
  {
    id: "payment",
    icon: "ri-wallet-3-line",
    title: "稿费怎么结算？",
    summary: "按线索价值分三档，采纳后 3 个工作日内结算，最快可做到 24 小时到账。",
    points: [
      "稿费与线索是否被采纳、信息增量大小、可核验程度相关，与文字长短无关。",
      "确认采纳后，编辑会通过你预留的方式确认收款渠道，无需额外支付任何费用。",
      "同一事件如由多人投稿，以最先提供可核验关键细节者为准。",
    ],
    note: "任何以“押金”“手续费”“加急费”名义要钱的，都不是我们。",
  },
  {
    id: "format",
    icon: "ri-file-list-3-line",
    title: "格式有什么要求？",
    summary: "讲清五要素：时间、地点、人物、经过、证据，附件比长篇叙述更有用。",
    points: [
      "用一段话概括事件，再按时间顺序补充细节，避免大量情绪化表达与主观推测。",
      "强烈建议附上截图、票据、录音、文件等原始材料，并说明获取途径。",
      "正文控制在 500 字以内，细节过多时可先提交摘要，编辑会主动联系补充。",
    ],
    note: "材料越原始、时间线越清晰，核验越快，发布也越快。",
  },
];

export const timelineRows = [
  {
    type: "普通社会线索",
    first: "约 4 小时",
    review: "4–8 小时",
    publish: "24–48 小时",
    level: "standard",
  },
  {
    type: "消费维权 / 行业乱象",
    first: "约 4 小时",
    review: "8–24 小时",
    publish: "48–72 小时",
    level: "standard",
  },
  {
    type: "涉及职务违规",
    first: "6–12 小时",
    review: "1–2 个工作日",
    publish: "3–5 天",
    level: "sensitive",
  },
  {
    type: "多人 / 多方交叉事件",
    first: "6–12 小时",
    review: "2–3 个工作日",
    publish: "5–7 天",
    level: "sensitive",
  },
];

export const privacyPoints = [
  {
    icon: "ri-eye-off-line",
    title: "默认匿名发布",
    desc: "除非你明确要求署名，否则对外一律以匿名处理，正文不出现可定位到个人的描述。",
  },
  {
    icon: "ri-lock-2-line",
    title: "联系方式分层存放",
    desc: "联系方式与线索正文分开存储，仅负责核验的编辑可查看，杜绝二次流转。",
  },
  {
    icon: "ri-shield-check-line",
    title: "身份信息可删除",
    desc: "如线索不采用，你可以在 30 天内要求删除投稿内容与联系方式。",
  },
  {
    icon: "ri-door-lock-line",
    title: "不向被爆料方透露",
    desc: "核验过程中不会向当事方提及投稿来源，也不会提供任何可反推的细节。",
  },
  {
    icon: "ri-device-line",
    title: "建议更换投稿环境",
    desc: "高风险线索请避免使用单位网络与办公设备，优先使用个人设备提交。",
  },
  {
    icon: "ri-customer-service-2-line",
    title: "专人单线对接",
    desc: "敏感线索由指定编辑单线联系，减少经手环节，降低信息扩散风险。",
  },
];

export const feeTiers = [
  {
    name: "线索采用",
    price: "100–300 元",
    criteria: "提供真实可核验的事件信息，经核实后形成短讯发布。",
    cycle: "采纳后 3 个工作日内",
    highlight: false,
  },
  {
    name: "深度爆料",
    price: "300–1500 元",
    criteria: "附带原始材料或独家细节，支撑起一篇完整报道的核验链条。",
    cycle: "发布后 3 个工作日内",
    highlight: true,
  },
  {
    name: "系列追踪",
    price: "1500 元起",
    criteria: "具备持续跟进价值，可形成系列报道或推动问题实质解决。",
    cycle: "按阶段协商结算",
    highlight: false,
  },
];

export const formatChecklist = [
  "一句话概括事件核心，让编辑第一眼知道发生了什么",
  "按时间顺序写清起因、经过、当前进展",
  "标明事件发生的地点与大致时间范围",
  "说明你与事件的关联以及信息来源的可靠性",
  "附上可核验的原始材料：截图、票据、录音、文件",
  "写明是否需要匿名，以及需要保护的身份信息",
  "留下可用的联系方式，方便核验时补充细节",
];

export const formatGoodExample =
  "某市××路一连锁餐饮门店，2026 年 3 月起用过期原料制作餐食。我 5 月在职期间拍摄到后厨照片 3 张、进货单据 2 份，另有同期离职同事可作旁证。店长曾口头要求“不要让检查看到过期标签”。本人需匿名，姓名与工号请务必保密。";

export const formatBadExample =
  "太气人了！这家店简直没法说，东西特别差，我朋友说他们一直这么干，反正就是坑人，你们赶紧来曝光他们吧！！！";

export const rejectReasons = [
  {
    title: "信息无法核验",
    detail: "只有主观描述，没有时间、地点或任何可查证的材料，编辑无法确认事件是否真实发生。",
    fix: "补充具体时间、地点与至少一项原始材料，哪怕是一张带日期的截图。",
  },
  {
    title: "与公共利益无关",
    detail: "纯属个人情感纠纷、家庭矛盾或私人恩怨，不具备公共价值，不属于爆料范畴。",
    fix: "先判断事件是否会影响其他消费者或公众，若仅涉及个人请通过其他途径解决。",
  },
  {
    title: "已有公开报道",
    detail: "所提供内容与已发布报道高度重合，且没有任何信息增量。",
    fix: "补充独家细节、最新进展或报道中未提及的证据，让线索具备二次价值。",
  },
  {
    title: "涉嫌侵权或造谣",
    detail: "内容包含未经证实的指控、对特定个人的恶意描述，或明显侵犯他人隐私。",
    fix: "只陈述你亲眼所见、可举证的事实，去掉主观定性与未经证实的转述。",
  },
  {
    title: "重复投稿",
    detail: "同一事件在短时间内被多次提交，以最先提供可核验关键细节的版本为准。",
    fix: "无需重复提交，若有新进展可在原线索基础上补充说明。",
  },
];

export const faqs = [
  {
    q: "爆料投稿后多久能收到回复？",
    a: "工作时段提交的线索，初审平均在 4 小时内完成并给出状态反馈；夜间提交的会顺延到次日 9:00 开始处理。无论是否采用，7 天内都会收到明确答复。",
  },
  {
    q: "完全匿名投稿也可以吗？",
    a: "可以。联系方式不是必填项，你可以选择不留下任何联系方式投稿。不过留下一种可靠的联系渠道，能显著提高核验与采纳的成功率。",
  },
  {
    q: "投稿需要提供真实姓名吗？",
    a: "不强求姓名，但需要在投稿时说明你的身份背景与信息来源。真实身份仅用于编辑判断信息可靠性，绝不会出现在发布内容中。",
  },
  {
    q: "我的联系方式会被转给其他机构吗？",
    a: "不会。联系方式与线索正文分开存储，仅负责核验的编辑可见，我们不会向被爆料方、合作机构或任何第三方提供。",
  },
  {
    q: "稿费什么时候结算，需要交税吗？",
    a: "确认采纳后 3 个工作日内结算，最快 24 小时到账。依法需要代扣代缴的部分按当地规定处理，结算时会明确告知实得金额。",
  },
  {
    q: "投稿不采用，材料会被怎么处理？",
    a: "未采用的线索会在内部留存用于比对，你可以在 30 天内联系我们要求删除投稿内容与联系方式，删除后不留副本。",
  },
  {
    q: "可以帮忙删掉已经收到的稿件吗？",
    a: "可以。用投稿时的联系方式回复邮件说明需要删除的稿件即可，我们会在 3 个工作日内完成删除并回复确认。",
  },
];

export const testimonials = [
  {
    quote:
      "按指南整理好时间线和截图后提交，当天下午就有人来核实，第二天看到内容发布，整个过程比想象中顺畅。",
    name: "匿名投稿人 A",
    role: "消费维权线索",
  },
  {
    quote:
      "我最担心的是被单位发现，投稿时说明了需要保护工号和部门，发布出来后这些信息一个都没有出现。",
    name: "匿名投稿人 B",
    role: "行业内部线索",
  },
  {
    quote:
      "第一次投稿写得太乱被退回了，按格式要求重新整理一遍就通过了，稿费也在三个工作日内到账。",
    name: "投稿人 陈先生",
    role: "社区民生线索",
  },
];

export const footerColumns = [
  {
    title: "投稿指南",
    links: [
      { label: "投稿流程", href: "#process" },
      { label: "审核时长", href: "#timeline" },
      { label: "格式要求", href: "#format" },
      { label: "审核不通过原因", href: "#reject" },
    ],
  },
  {
    title: "权益保障",
    links: [
      { label: "隐私保护机制", href: "#privacy" },
      { label: "稿费结算规则", href: "#fee" },
      { label: "常见问题", href: "#faq" },
      { label: "我要投稿", href: "#submit" },
    ],
  },
];